import { createSlice } from '@reduxjs/toolkit';
import { ApplicationInstallStateType } from '../../types/ApplicationInstall';

const initialState: ApplicationInstallStateType = {
    data: null,
    loading: false,
    error: false,
};
export const applicationInstallSlice = createSlice({
    name: 'applicationInstallDetail',
    initialState,
    reducers: {
        getApplicationInstallFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getApplicationInstallFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getApplicationInstallFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        installApplicationInstallFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        installApplicationInstallFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        installApplicationInstallFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        activateApplicationInstallFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        activateApplicationInstallFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        activateApplicationInstallFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        deactivateApplicationInstallFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        deactivateApplicationInstallFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        deactivateApplicationInstallFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        clearApplicationInstall: () => initialState,
    },
});

export const {
    getApplicationInstallFetch,
    getApplicationInstallFetchSuccess,
    getApplicationInstallFetchFailure,
    installApplicationInstallFetch,
    installApplicationInstallFetchSuccess,
    installApplicationInstallFetchFailure,
    activateApplicationInstallFetch,
    activateApplicationInstallFetchSuccess,
    activateApplicationInstallFetchFailure,
    deactivateApplicationInstallFetch,
    deactivateApplicationInstallFetchSuccess,
    deactivateApplicationInstallFetchFailure,
    clearApplicationInstall,
} = applicationInstallSlice.actions;

export default applicationInstallSlice.reducer;
